var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon",class:_vm.icon,attrs:{"title":_vm.filterIcon},domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon])}})
}
var staticRenderFns = []

export { render, staticRenderFns }